/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AllGamesQuestsSummary
 */
export interface AllGamesQuestsSummary {
    /**
     * 
     * @type {number}
     * @memberof AllGamesQuestsSummary
     */
    totalGames?: number;
    /**
     * 
     * @type {number}
     * @memberof AllGamesQuestsSummary
     */
    totalQuests?: number;
    /**
     * 
     * @type {number}
     * @memberof AllGamesQuestsSummary
     */
    gamesWithProgress?: number;
}

/**
 * Check if a given object implements the AllGamesQuestsSummary interface.
 */
export function instanceOfAllGamesQuestsSummary(value: object): value is AllGamesQuestsSummary {
    return true;
}

export function AllGamesQuestsSummaryFromJSON(json: any): AllGamesQuestsSummary {
    return AllGamesQuestsSummaryFromJSONTyped(json, false);
}

export function AllGamesQuestsSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllGamesQuestsSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'totalGames': json['totalGames'] == null ? undefined : json['totalGames'],
        'totalQuests': json['totalQuests'] == null ? undefined : json['totalQuests'],
        'gamesWithProgress': json['gamesWithProgress'] == null ? undefined : json['gamesWithProgress'],
    };
}

export function AllGamesQuestsSummaryToJSON(json: any): AllGamesQuestsSummary {
    return AllGamesQuestsSummaryToJSONTyped(json, false);
}

export function AllGamesQuestsSummaryToJSONTyped(value?: AllGamesQuestsSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalGames': value['totalGames'],
        'totalQuests': value['totalQuests'],
        'gamesWithProgress': value['gamesWithProgress'],
    };
}

